import React from 'react'
import { formatDate } from '../utils/dateUtils'
import { Panel } from 'react-bootstrap'

export default function CheckInOutDates({ checkInDate, checkOutDate }) {
  return (
    <Panel>
      <p>
        <b>Check in:</b>
        <br />
        {formatDate(checkInDate, true)}
      </p>
      <p>
        <b>Check out:</b>
        <br />
        {formatDate(checkOutDate, true)}
      </p>
    </Panel>
  )
}



// WEBPACK FOOTER //
// ./src/components/checkInOutDates.js